var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video"},[_c('video',{ref:"video",attrs:{"src":_vm.src,"poster":_vm.poster,"loop":"","controls":!_vm.muted,"playsinline":"","preload":"metadata"},domProps:{"muted":_vm.muted}})])}
var staticRenderFns = []

export { render, staticRenderFns }